@if (!activeUser && this.isLoggedIn) {
  <div class="activation-panel">
    <div class="activation-brand">
      <img src="assets/img/logo.png" alt="">
      <span class="activation-brand-word">Fusion</span>
    </div>
    <div class="activation-body">
      <p class="activation-user">{{username}}</p>
      <p class="activation-message">{{'USER.WAITING-ACTIVATION'| translate}}</p>
      <button type="button" class="btn btn-outline-secondary" (click)="logout()">
        <lucide-icon name="log-out" size="18" style="margin-right:4px;"></lucide-icon>
        {{'HEADER.LOGOUT' | translate}}
      </button>
    </div>
  </div>
} @else {
  @if (!isControlModule) {
    <app-fusion-nav-header>
    </app-fusion-nav-header>
  } @else {
    <app-control-module-nav-header>
    </app-control-module-nav-header>
  }
  <!--
    The content panel, and ONLY for someone who is signed in.

    .main reserves 260px on the left for the side menu and 82px on top for the
    navbar. The nav header hides itself for an anonymous visitor (see
    header.component.html), but those gutters were applied regardless -- so the
    login card was centred inside a box that had been pushed right and down by
    chrome that was not on the screen. Hence no class at all when there is no
    session: the auth pages are full-viewport shells of their own.
  -->
  <div [ngClass]="{'main': hasSession && !isControlModule && !isFullWidth, 'main-control': hasSession && (isControlModule || isFullWidth)}">
    <main #mainContent>
      <router-outlet></router-outlet>
    </main>
  </div>
}

